module.exports = __webpack_public_path__ + "static/media/foto3.45e73464.png";